// Match or closest helper
export default function getTarget($target, match) {
  if (!$target || !$target.closest || !$target.matches) return false;
  return $target.closest(match) || ($target.matches(match) && $target) || false;
}
